import { useEffect, useState } from "react";
import { api } from "../../booking/api";

const CARDS = [
  { key: "active_services", label: "Active services" },
  { key: "categories", label: "Categories" },
  { key: "providers", label: "Providers" },
  { key: "resource_units", label: "Resource units" },
  { key: "statuses", label: "Booking statuses" },
];

export default function Dashboard() {
  const [counts, setCounts] = useState(null);

  useEffect(() => {
    api.get("/api/admin/overview").then((r) => setCounts(r.data)).catch(() => setCounts({}));
  }, []);

  return (
    <div data-testid="admin-dashboard">
      <h1 className="text-2xl font-semibold mb-1">Dashboard</h1>
      <p className="text-sm text-muted-foreground mb-6">Phase 1 — setup data. Bookings calendar arrives in Phase 3.</p>
      <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
        {CARDS.map(({ key, label }) => (
          <div key={key} className="bg-white rounded-lg border p-5">
            <p className="text-3xl font-semibold">{counts ? counts[key] ?? 0 : "–"}</p>
            <p className="text-xs text-muted-foreground mt-1">{label}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
